// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 831) return "static/chunks/bd904a5c-da3ff32443870027.js";
	if (chunkId === 525) return "static/chunks/525-d11871582f1d03d2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"367":"b536a0f1","413":"f6211eb1","510":"72c373f8","664":"a3cd4a83"}[chunkId] || chunkId) + "." + {"44":"f8937035d78f4d85","367":"d3dc022ba49952f8","413":"12746e5c2c060662","424":"170c1287da9bce98","510":"9dd8e07ca2521dcb","664":"afe7013ebe367770"}[chunkId] + ".js";
};